import { ElementWrapper } from '../../../components/ElementWrapper';
import { StaticWidthInlineEdit } from '../../../components/StaticWidthInlineEdit';
import { IElement } from '../../../models/Element';
import { FormCancellation } from './FormCancellation';

type FormCancellationFCProps = {
  index: number;
  data: FormCancellation;
  updateData: (element: IElement, index: number) => void;
};

export const FormCancellationFC = ({
  index,
  data,
  updateData,
}: FormCancellationFCProps) => {
  const update = (fieldsToUpdate: Partial<FormCancellation>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <ElementWrapper elementIndex={index}>
      <div className="form-interested-in">
        <div className="form-interested-in__content">
          <StaticWidthInlineEdit
            name="title"
            className="title"
            value={data.title}
            setValue={update}
          />

          <div className="form-field-group">
            <StaticWidthInlineEdit
              name="heading_primary"
              className="heading-text"
              value={data.heading_primary}
              setValue={update}
            />

            {/* The field labels below are hardcoded in the API blade template
                and cannot be edited here. */}
            <div className="d-flex justify-content-between gap-4">
              <div className="form-field w-100">
                <a>
                  <span>Naam</span>
                </a>
              </div>

              <div className="form-field w-100">
                <a>
                  <span>E-mailadres</span>
                </a>
              </div>
            </div>

            <div className="d-flex justify-content-between gap-4">
              <div className="form-field w-100">
                <a>
                  <span>Bedrijfsnaam</span>
                </a>
              </div>

              <div className="form-field w-100">
                <a>
                  <span>Klantnummer</span>
                </a>
              </div>
            </div>

            <div className="form-field">
              <a>
                <span>Gewenste einddatum</span>
              </a>
            </div>
          </div>

          <div className="form-field-group">
            <span className="heading-text">
              We willen graag leren, kan je ons meer vertellen over de reden van
              opzeggen?
            </span>

            <div className="form-field">
              <a className="form-field__textarea">
                <span>Reden van opzegging</span>
              </a>
            </div>

            <div className="form-field">
              <a>
                <span>
                  Onder welke van de onderstaande redenen past jouw reden het
                  beste?
                </span>
              </a>
            </div>
          </div>

          <div className="form-field-group">
            <span className="heading-text">Voor akkoord</span>

            <div className="form-field">
              <a>
                <span>Ja ik ga akkoord</span>
              </a>
            </div>
          </div>

          {/* begin::Action Button */}
          <div className="action">
            <a>
              <span className="action-text">Versturen</span>
            </a>
          </div>
          {/* end::Action Button */}

          <StaticWidthInlineEdit
            name="success_message"
            className="text-white"
            value={
              data.success_message ??
              'We hebben je opzegging ontvangen en nemen deze zo snel mogelijk in behandeling.'
            }
            setValue={update}
          />
        </div>
      </div>
    </ElementWrapper>
  );
};
